var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from "react";
import filterProps from "../utils/filter-props";
import { createPolymorphicComponent } from "../utils/types/polymorphic-component";
export const Button = forwardRef((props, ref) => {
    const { ariaLabel, dataAnchor, component = "button" } = props, rest = __rest(props, ["ariaLabel", "dataAnchor", "component"]);
    const Component = component;
    return (React.createElement(Component, Object.assign({ ref: ref, type: "button", "aria-label": ariaLabel, "data-anchor": dataAnchor }, filterProps(rest))));
});
export default createPolymorphicComponent(Button);
